module.exports = new __parcel__URL__("butterfly.f41d19d4.svg").toString();